import React from 'react';
import styled from 'styled-components';

import { Box, Text } from 'grommet';

const Container = styled.div`
  max-width: 600px;
  max-height: 600px;
  margin: 32px auto;
`;

const Image = styled.img`
  max-width: 100%;
  height: auto;
`;

class Picture extends React.Component {
  render() {
    const { content } = this.props;
    const source = content.source.startsWith('http')
      ? content.source
      : require('../../../content' + content.source);
    return (
      <Container>
        <Box aria-label="figure" align="center">
          <Image src={source} alt={content.caption} />
          {content.caption && (
            <Text weight="bold" textAlign="center">
              {content.caption}
            </Text>
          )}
        </Box>
      </Container>
    );
  }
}

export default Picture;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/Picture.js